import { isLoggedIn } from 'infra/http';
import InitializeIntercom from 'intercom';
import { SET_LANGUAGE } from 'localization/reducer';
import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUserData } from 'store/slices';
import { actions as userDetailAction } from 'userDetail';

export type Props = {
  children?: React.ReactNode;
};

export const AuthProvider = ({ children }: Props) => {
  const dispatch = useDispatch();

  const { isAuthenticated, tokenData } = isLoggedIn();

  useLayoutEffect(() => {
    dispatch({
      type: SET_LANGUAGE,
      lang: 'en'
    });
    if (isAuthenticated) {
      dispatch(
        setUserData({
          email: tokenData?.email,
          isAdmin: tokenData?.isAdmin,
          tier: tokenData?.tier,
          productType: tokenData?.productType
        })
      );
      dispatch(userDetailAction.getUserDetails());

      if (process.env.REACT_APP_ENABLE_INTERCOM === 'true') {
        InitializeIntercom();
      }
    }
  }, [dispatch, isAuthenticated, tokenData]);

  return <>{children}</>;
};
